// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__331We","approved":"Status_approved__2X7lK","rejected":"Status_rejected__3KSn3","expired":"Status_expired__2x0aR","label":"Status_label__2EcdR"};